import { useQuery } from '@tanstack/react-query'

import { apiGetRegionList } from '@/apis/serviceArea/getRegionList'

import { SERVICE_AREA_KEYS } from '../keys/serviceArea'

/**
 * 광역권역 리스트 조회.
 *
 * 캐싱 정책: 광역권역 목록은 한 세션 내에서 거의 변하지 않으므로 staleTime/gcTime 모두 Infinity.
 * 한 번 받으면 재페치 안 함 (focus refetch / mount refetch 방지).
 */
export const useGetRegionList = () => {
  return useQuery({
    queryKey: [SERVICE_AREA_KEYS.REGION_LIST],
    queryFn: apiGetRegionList,
    staleTime: Infinity,
    gcTime: Infinity,
  })
}
